// extracted by mini-css-extract-plugin
export default {"HeaderButton":"header-button_HeaderButton__NwuH5","active":"header-button_active__OUfUw"};